import { makeStyles } from '@material-ui/styles';

import {
  MAIN_LAYOUT_FOOTER_HEIGHT,
  MAIN_LAYOUT_HEADER_HEIGHT,
  ORDER_DETAIL_MAX_WIDTH,
} from 'shared/styles/constants';

export default makeStyles({
  backdropRoot: {
    marginTop: MAIN_LAYOUT_HEADER_HEIGHT,
    marginBottom: MAIN_LAYOUT_FOOTER_HEIGHT,
  },
  root: {
    inset: 'unset !important',
  },
  paper: {
    height: `calc(100% - ${MAIN_LAYOUT_HEADER_HEIGHT} - ${MAIN_LAYOUT_FOOTER_HEIGHT})`,
    width: '100%',
    maxWidth: ORDER_DETAIL_MAX_WIDTH,
    marginTop: MAIN_LAYOUT_HEADER_HEIGHT,
    marginBottom: MAIN_LAYOUT_FOOTER_HEIGHT,
  },
});
